import * as React from 'react';

// import Card from '@mui/material/Card';
import { IStatInfo } from '../interfaces';

interface IProps {
  id?: string;
  cardInfo: IStatInfo;
}

function StatCard(props: IProps) {
  const {
    id,
    cardInfo: { description },
  } = props;

  return (
    <div id={id} className="home-page__stat-card">
      <h3 className={'stat-card-title'} />
      <p className="stat-card-description">{description}</p>
    </div>
  );
}

export { StatCard };
